module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-latin-ext24.ae1b454.woff2";